module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Semibold.6fe75b52a4efb580de12151a3385b7ff.eot";